import { render, staticRenderFns } from "./RecentAccessTotal.vue?vue&type=template&id=860e04b2&scoped=true"
import script from "./RecentAccessTotal.vue?vue&type=script&lang=js"
export * from "./RecentAccessTotal.vue?vue&type=script&lang=js"
import style0 from "./RecentAccessTotal.vue?vue&type=style&index=0&id=860e04b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e04b2",
  null
  
)

export default component.exports